import { SOUNDS } from "../contexts/SoundContext";
import { BOTTOM_BUTTONS, DART_HITS } from "../types/dart";
import { getSoundLocalStorage } from "./localStorage";

export function playAudio(marks: number): void {
  if (!getSoundLocalStorage()) return;
  let id: SOUNDS;
  switch (marks) {
    case BOTTOM_BUTTONS.MISS:
      id = SOUNDS.MISS;
      break;
    case BOTTOM_BUTTONS.END_TURN:
      id = SOUNDS.MISS;
      break;
    case 0:
      id = SOUNDS.MISS;
      break;
    case DART_HITS.SINGLE:
      id = SOUNDS.SINGLE;

      break;
    case DART_HITS.DOUBLE:
      id = SOUNDS.DOUBLE;

      break;
    case DART_HITS.TRIPLE:
      id = SOUNDS.TRIPLE;
      break;
    default:
      id = SOUNDS.MISS;
      break;
  }
  if (!id) return;
  var x: HTMLAudioElement | null = document.getElementById(
    id
  ) as HTMLAudioElement;
  if (!x) return;
  x.currentTime = 0;
  x.play();
}

export function playGameOverAudio(): void {
  if (!getSoundLocalStorage()) return;
  const id = SOUNDS.GAME_OVER;
  if (!id) return;
  var x: HTMLAudioElement | null = document.getElementById(
    id
  ) as HTMLAudioElement;
  if (!x) return;
  x.currentTime = 0;
  x.play();
}